import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clientService } from "../../../services";
import { Col } from "reactstrap";

import backgroundImage from "../../../assets/images/backgroundImage.png"; // Update with your background image path
import signBanner from "../../../assets/images/emailVerified.png";
import barcode from "../../../assets/images/barcode.png";
import googleButton from "../../../assets/images/blackGoogleButton.png";
import appleButton from "../../../assets/images/blackAppleButton.png";
import successIcon from "../../../assets/images/successIcon.png";
import errorIcon from "../../../assets/images/errorIcon.png"; // Update with your error message image path

import "./EmailVerification.css"; // Assuming you have a CSS file for styling

const EmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [responseMessage, setResponseMessage] = useState({
    showBtn: true,
    message: "",
  });

  const { search, pathname } = useLocation();

  const hasRun = useRef(false); // Ref to ensure handleUpdate only runs once

  // Function to validate if the URL path and token query are correct
  const isValidPath = () => {
    const isEmailVerifiedPath = pathname.startsWith("/emailVerified/");
    const hasToken = search.includes("?token=");
    return isEmailVerifiedPath && hasToken;
  };

  useEffect(() => {
    if (isValidPath() && !hasRun.current) {
      hasRun.current = true; // Mark as run
      handleUpdate();
    }
  }, [search]);


  const handleUpdate = async () => {
    setIsLoading(true);
    setError(null); // Reset error

    try {
      let postClient;

      // Example of the clientService call to update client details
      postClient = await clientService.updateLeadInfo(
        search.split("?token=")[1]
      );

      // If message indicates the link is expired, handle accordingly
      if (postClient?.status === 202) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else if (postClient?.status === 201) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else {
        setIsLinkExpired(false);
        setResponseMessage({
          showBtn: true,
          message: postClient?.data?.message,
        });
      }
    } catch (err) {
      console.error("Error during verification:", err);
      setError(
        "There was an error verifying your email. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // If the URL path is not valid, show "Page Not Found"
  if (!isValidPath()) {
    return (
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`, // Update with your background image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="sideContentWrapper">
          <Col md={6}>
            <h2 style={{ color: "red" }}>Page Not Found</h2>
            <p>
              The page you are looking for does not exist or the link is
              invalid.
            </p>
          </Col>
          {/* RIGHT STICKY IMAGE COLUMN */}
          <Col md={6} className="position-relative p-0 d-none d-sm-block">
            <div className="sideImageWrapper">
              <img
                src={signBanner}
                alt="godoBanner"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <Col md={8} className="emailHeadingContent">
                <div className="bannerHeadingEmailVerified text-black px-4">
                  <h1>Join thousands of traders on the the GODO App!</h1>
                  <p>
                    Trader 4000+ assets, invest in 3000+ stocks with 0%
                    commission, Autocopy top traders, and access powerful tool
                    and eduction - all from one easy-to-use app.
                  </p>
                </div>
              </Col>
              <Col md={4} className="emailLinkWrapper">
                <div className="linkWrapper d-flex flex-column gap-3 align-items-center">
                  <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                    <img src={googleButton} alt="googleButton" />
                  </a>
                  <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                    <img src={appleButton} alt="appleButton" />
                  </a>
                </div>
                <img
                  className="barcodeEmailVerified"
                  src={barcode}
                  alt="barcode"
                />
              </Col>
            </div>
          </Col>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`, // Update with your background image path
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="sideContentSuccessWrapper">
        <Col md={6} className="sideContinerHeight">
          {/* Logo at the top */}
          <div className="logoImage">
            <img
              src="https://www.godocm.com/wp-content/uploads/2025/05/cropped-GoDo-Logo-7-1.png" // Update with your logo path
              alt="Company Logo"
            />
          </div>

          {isLoading ? (
            <div className="responseMessage" style={{ fontSize: "16px", marginTop: '30px', color: "#555", height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <div className="loader"></div> {/* The loader */}
            </div>
          ) : error ? (
            <div className="responseMessage" style={{ fontSize: "16px", marginTop: '30px', color: "red", height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <img src={errorIcon} alt="errorIcon" width={"80px"} />
              <p>{error}</p>
            </div>
          ) : isLinkExpired ? (
            <div className="responseMessage" style={{ textAlign: "center", marginTop: '30px', height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <p style={{ fontSize: "16px", color: "red" }}>
                {responseMessage.message}
              </p>
            </div>
          ) : (
            <div
              className="responseMessage"
              style={{
                fontSize: "16px",
                color: "#555",
                textAlign: "center",
              }}
            >
              <img src={successIcon} alt="succcessIcon" width={"80px"} />
              <p className="mt-5">{responseMessage.message}</p>
            </div>
          )}

          {/* Conditionally render the Login Button or Expired message */}
          {!isLinkExpired &&
            !isLoading &&
            !error &&
            responseMessage.showBtn && (
              <div className="portalButton" style={{ textAlign: "center" }}>
                <a
                  href="https://login.godocapitalmarkets.com/login/" // Update with your portal URL
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#094D96",
                    color: "#fff",
                    textDecoration: "none",
                    borderRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Login to Client Portal
                </a>
              </div>
            )}
        </Col>
        {/* RIGHT STICKY IMAGE COLUMN */}
        <Col md={6} className="position-relative p-0 d-none d-sm-block">
          <div className="sideImageWrapper">
            <img
              src={signBanner}
              alt="godoBanner"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <Col md={8} className="emailHeadingContent">
              <div className="bannerHeadingEmailVerified text-black px-4">
                <h1>Join thousands of traders on the the GODO App!</h1>
                <p>
                  Trader 4000+ assets, invest in 3000+ stocks with 0%
                  commission, Autocopy top traders, and access powerful tool and
                  eduction - all from one easy-to-use app.
                </p>
              </div>
            </Col>
            <Col md={4} className="emailLinkWrapper">
              <div className="linkWrapper d-flex flex-column gap-3 align-items-center">
                <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                  <img src={googleButton} alt="googleButton" />
                </a>
                <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                  <img src={appleButton} alt="appleButton" />
                </a>
              </div>
              <img
                className="barcodeEmailVerified"
                src={barcode}
                alt="barcode"
              />
            </Col>
          </div>
        </Col>
      </div>
    </div>
  );
};

export default EmailVerification;
